var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{attrs:{"breadcrumbs":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{class:_vm.$style.headerActions},[_c('h1',[_vm._v(_vm._s(_vm.eventName))]),_c('div',{class:_vm.$style.actionsRight},[(
            _vm.isEventStatus('DRAFT') && _vm.isJbicEventUpdateRole && !_vm.eventIsEnded
          )?_c('b-button',{attrs:{"type":"is-primary"},on:{"click":_vm.submitEventForApprovalHandler}},[_vm._v(" Submit for Approval ")]):_vm._e(),(
            _vm.isEventStatus('AWAITING_APPROVAL') &&
            _vm.isJbicEventManageRole &&
            !_vm.eventIsEnded
          )?_c('b-button',{attrs:{"type":"is-primary"},on:{"click":_vm.approveEvent}},[_vm._v(" Approve ")]):_vm._e(),(
            _vm.isEventStatus('AWAITING_APPROVAL') &&
            _vm.isJbicEventManageRole &&
            !_vm.eventIsEnded
          )?_c('b-button',{on:{"click":_vm.declineEvent}},[_vm._v(" Deny ")]):_vm._e(),(
            _vm.isEventStatus('APPROVED') &&
            _vm.isJbicEventUpdateRole &&
            !_vm.eventIsEnded
          )?_c('b-button',{attrs:{"type":"is-primary"},on:{"click":_vm.publishEvent}},[_vm._v(" Publish ")]):_vm._e(),(
            _vm.isEventStatus('PUBLISHED') &&
            _vm.isJbicEventUpdateRole &&
            !_vm.eventIsEnded
          )?_c('b-button',{attrs:{"type":"is-primary"},on:{"click":_vm.unpublishEvent}},[_vm._v(" Unpublish ")]):_vm._e(),(
            !_vm.isEventStatus('PUBLISHED') &&
            _vm.isJbicEventUpdateRole &&
            !_vm.eventIsEnded
          )?_c('b-button',{on:{"click":_vm.editEvent}},[_vm._v(" Edit ")]):_vm._e(),(_vm.isJbicEventDeleteRole)?_c('b-button',{staticClass:"is-ghost",class:_vm.$style.deleteButton,attrs:{"outlined":""},on:{"click":_vm.deleteEvent}},[_vm._v(" Delete ")]):_vm._e()],1)])]},proxy:true}])},[_c('EventViewComponent',{attrs:{"currentEvent":_vm.jbicEvent,"lastReviewedEvent":_vm.lastReviewedEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }